export const steps = ['Account', 'Persönliche Daten', 'Körperdaten'];
